import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
  Container,
  CardColumns,
  Jumbotron,
  Button,
  Spinner,
} from 'react-bootstrap';
import { AppState } from '../store/config';
import {
  getUserSupportTickets,
  createSupportTicket,
} from '../state/actions/support/actions';
import { decodeToken } from '../utils/checkToken';
import TicketCard from '../components/TicketCard';
import { DashboardStyle, Footer, Loaders } from './styles/dashboard';
import TicketModal from '../components/CreateTicketModal';
import Nav from '../components/Navbar';

type Props = ReturnType<typeof mapStateToProps> & any;
const Dashboard: React.FC<Props> = ({
  getUserSupportTickets,
  createSupportTicket,
  tickets,
  ticket,
  loading,
}) => {
  const [show, setShow] = useState(false);
  const user = decodeToken();
  useEffect(() => {
    getUserSupportTickets(user!.id);
  }, [getUserSupportTickets, ticket]);

  return (
    <>
      <DashboardStyle>
        <Nav />
        {loading ? (
          <Loaders>
            <Spinner animation="border" variant="primary" />
          </Loaders>
        ) : (
          <>
            <Jumbotron>
              <Container>
                <h3>Welcome {user!.username}!</h3>{' '}
                <p>How can help you today?</p>
                <p>
                  <Button variant="primary" onClick={() => setShow(true)}>
                    Create new ticket
                  </Button>
                </p>
              </Container>
            </Jumbotron>

            <TicketModal
              show={show}
              setShow={setShow}
              loading={loading}
              createSupportTicket={createSupportTicket}
            />

            <Container className="section">
              <CardColumns>
                {tickets?.tickets.length > 0
                  ? tickets?.tickets.map((ticket: any, idx: number) => (
                      <TicketCard ticket={ticket} key={idx} />
                    ))
                  : "You don't have any tickets"}
              </CardColumns>
            </Container>
          </>
        )}
      </DashboardStyle>
      <Footer>
        <Container>
          {new Date().getFullYear()} &copy; Made with React Bootstrap
        </Container>
      </Footer>
    </>
  );
};

const mapStateToProps = ({ supportReducer }: AppState) => ({
  loading: supportReducer.loading,
  tickets: supportReducer.tickets,
  ticket: supportReducer.ticket,
  error: supportReducer.error,
});

export default connect(mapStateToProps, {
  getUserSupportTickets,
  createSupportTicket,
})(Dashboard);
